export class Platform implements IPlatform {
  id?: string | undefined;
  title?: string | undefined;
  buildFolder?: string | undefined;

  constructor(data?: IPlatform) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.title = _data['title'];
      this.buildFolder = _data['buildFolder'];
    }
  }

  static fromJS(data: any): Platform {
    data = typeof data === 'object' ? data : {};
    const result = new Platform();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['buildFolder'] = this.buildFolder;
    return data;
  }
}

export interface IPlatform {
  id?: string | undefined;
  title?: string | undefined;
  buildFolder?: string | undefined;
}